import React, { Component } from 'react';
import Slider from 'react-slick';
import Dfp from './Dfp';
import Immutable from 'immutable';
import 'whatwg-fetch';

class RightNavButton extends Component {
  render() {
		return <button type="button" className="slick-next" {...this.props}><div className="slick-cap" >Next</div></button>
  }
}
class LeftNavButton extends Component {
  render() {
		return <button type="button" className="slick-prev" {...this.props}><div className="slick-cap">Previous</div></button>
  }
}

class Superbanner extends Component {
	 constructor(){
		  super();
		  this.state = {
			  list:Immutable.List([]),
			  page:1,
		  }
		  
		  this.getSuperBanners = this.getSuperBanners.bind(this);
		  this.renderBanner = this.renderBanner.bind(this);
		  this.getSuperBanners();
	}

	getSuperBanners(){
		let that = this;
		let params = {
				home:1,
				page:1
			};
		let formData = new FormData();
		for (var k in params) {
			if(params.hasOwnProperty(k)){
				formData.append(k, params[k]);
			}
		}
		
		fetch('/wp-json/she-rest-api/getSuperBanners/',{
			method:"POST",
			body:formData
		}).then(function(res){ return res.json(); }).then(function(response){
			let arr = response.items;
			that.setState({ list:that.state.list.concat(Immutable.List(arr)),page:that.state.page+1});

		}).catch(function(error){
			 console.log(error);
		});
	}
	
	renderBanner( item ){ /* determine which template should be used for superbanner */
		let tmp;
		const { theme } = this.props;
		
		if(item.type==='normal'){
			tmp = <div className="ctable full-width">
			<div className="ctable-cell info-superbanner">
				<div className="info-superbanner-wrap1">
					<div className="info-superbanner-wrap2">
						<div className="bgcolor-superbanner" style={{ backgroundColor:item.bgColor }}>
						<div className="desc-superbanner">
							<div className="ctable">
								<div className="ctable-cell">
									<div className="channel-name-superbanner Abel" dangerouslySetInnerHTML={{ __html:item.categoryLabel }} ></div>
									<h1 className="title-superbanner Abel" >{item.post_title}</h1>
									<h2 className="content-superbanner Abel">{item.post_content}</h2>
									{
										( item.hasOwnProperty('author_name') ? 
										<div className="author-info ctable">
											<div className="ctable-cell">
												<div className="author_pic">
												<a href={item.author_url} >
													<div className="img" style={{ backgroundImage:'url('+ item.author_pic +')' }}>
														{
															(item.isVip==1 ? 
															<div className="blogger-tick"></div> :
															'')
														}
													</div>
												</a>
												</div>
											</div>
											<div className="ctable-cell">
												<h4 className="Abel">&nbsp;&nbsp;{ item.author_name }</h4>
												<div className="Abel">&nbsp;&nbsp;{ item.blogger_title }</div>
											</div>
										</div> :
										'' )
									}
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			</div>
			<div className="ctable-cell thumb-superbanner">
					<img src={item.thumbnail} width="100%" alt="img"/>
			</div>
		</div>
		}else if(item.type==='ad'){
			tmp = <div className="ctable full-width">
					<div className="ctable-cell info-superbanner">
						<div className="superbanner-ad">
						<Dfp 
							adUnit={ theme+ '_superbanner_1180x440' }
							sizes={[[1180,440], [600,700]]}
							sizeMapping={ [
								{viewport: [768, 0], sizes:[[1180, 440]]},
								{viewport: [0, 0], sizes:[[600, 700]] }
								]}
							targeting={[
								{ key:'brand',value:item.ad_target }
								]}
						/>
						</div>
					</div>
				</div>
		}else if(item.type==='full_width'){
			tmp = <div className="ctable full-width">
					<div className="ctable-cell info-superbanner">
						<div className="superbanner-full_width">
							<div className="thumbnial_desktop">
								<img src={item.thumbnail_desktop} width="100%" alt={item.post_title}/>
							</div>
							<div className="thumbnial_mobile">
								<img src={item.thumbnail_mobile} width="100%" alt={item.post_title}/>
							</div>
						</div>
					</div>
				</div>
		}
		
		return tmp;
	}
	
	 render() {
		const { list } = this.state;
		let that = this;
		
		if(list.size)	{
			let settings = {
				autoplay: true,
				autoplaySpeed: 4000,
				draggable:false,
				prevArrow: <LeftNavButton/>,
				nextArrow: <RightNavButton/>
			};
			
			return(
			  <div className="Superbanner">			
				<section className="block block-superbanner">
					<div className="slider-wrapper">
						<div className="slider">
							<Slider {...settings} >
								{
									list.map(function(item,index){
										return (
											<div key={index} className="item-superbanner" style={{ backgroundImage:'url('+item.bgPattern+')' }}  >
												<a href={ (item.url=='http://' ? 'javascript:void(0)' : item.url ) }>
													{that.renderBanner(item)}
												</a>
											</div>
										)
									})
								}
							</Slider>
						</div>
					</div>
					</section>
					</div>
				 );
		}else{
			return (
				<div></div>
			);
		}
	 }
}

export default Superbanner;


// WEBPACK FOOTER //
// ./src/Superbanner.js